import { render, staticRenderFns } from "./ComponentDetailsModal.vue?vue&type=template&id=af913bfc&scoped=true&"
import script from "./ComponentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ComponentDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ComponentDetailsModal.vue?vue&type=style&index=0&id=af913bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af913bfc",
  null
  
)

export default component.exports